export default function EnergyConserved(props: any) {
    return (
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.29371 26.0941C6.08568 15.1131 16.8774 7.4548 22.2261 4.39375C22.3089 4.34633 22.3961 4.29704 22.4875 4.24588C23.3238 3.77809 24.3851 3.99497 24.9603 4.75123C29.6154 10.8723 36.7212 22.5081 32.9223 28.5044C29.852 33.3505 23.2782 34.6253 18.1252 33.738C13.9719 33.0231 9.20785 30.6397 8.29371 26.0941Z"
                stroke="#010101"
                strokeWidth="2"
            />
            <path d="M27 23L21.923 28L16 23" stroke="#010101" strokeWidth="2" strokeLinecap="round" />
            <path d="M22 20V41" stroke="#010101" strokeWidth="2" strokeLinecap="round" />
        </svg>
    );
}
